import CryptoJS from 'crypto-js';
import qs from 'qs';
import Cookies from 'js-cookie'
import axios from 'axios';
import router from '@/router'
import COS from 'cos-js-sdk-v5';
import { Message } from 'element-ui';


var doHandleMonth = function(month){
    var m = month;
    if (month.toString().length == 1) {
        m = "0" + month;
    }
    return m;
}

export default {
    options: {
        Bucket: '91jf-10046268',
        Region: 'ap-shanghai',
        StorageClass: 'STANDARD',
    },
    cos:null,
    sourceip:null,
    api(url, params, callback) {
        var nowDate = new Date();
        var dateTime = nowDate.toUTCString();
        var SecretId = 'AKIDkhGhiK5898dqx54rZ2mnufqhcL57urizh2e2';
        var SecretKey = '2ntm0oF3DlgqA3havd4sa7M02bddyxH1xtt8d86u';
        var source = 'shop-admin';
        var auth = "hmac id=\"" + SecretId + "\", algorithm=\"hmac-sha1\", headers=\"x-date source\", signature=\"";
        var signStr = "x-date: " + dateTime + "\n" + "source: " + source;
        var sign = CryptoJS.HmacSHA1(signStr, SecretKey);
        var AccessToken = Cookies.get('ShopAdminToken');
        var baseUrl = '/api';
        var host = window.location.host;

        if(host.indexOf(':8082') == -1){
            baseUrl = 'https://shopadmin-api.91jf.com';
        }
        baseUrl = 'https://shopadmin-api.91jf.com';
        // console.log(AccessToken);
        sign = CryptoJS.enc.Base64.stringify(sign);
        sign = auth + sign + "\"";

        var ip = this.sourceip==null?this.getIp():this.sourceip;

        var instance = axios.create({
            baseURL: baseUrl,
            timeout: 10000,
            headers: {
                "Source": source,
                "X-Date": dateTime,
                "Authorization": sign,
                "ShopAdminToken": AccessToken,
                "Router": window.location.pathname,
                "SourceIp":ip
            },
            withCredentials: true
        });

        if (!params) {
            params = {};
        }

        instance.post(url, qs.stringify(params)).then(function (response) {
                // console.log(response);
                var status = response.status;
                var data = response.data;

                if (status != 200) {
                    console.log('请求失败，状态码：' + status);
                }

                if (data.code == 10036) {
                    router.push('/login');
                }

                if (data.code == 10217) {
                    router.push('/401');
                }

                if (data.code == 10217) {
                    router.push('/401');
                }

                if (callback) {
                    callback(data);
                }
            })
            .catch(function (error) {
                callback(error);
            });
    },
    loginStatus() {
        var token = Cookies.get('ShopAdminToken');
        if (token == null) {
            return false;
        }
        
        return true;
    },
    userinfo() {
        // var userinfo = localStorage.getItem("UserInfo");

        // if(userinfo != null){
        //     return JSON.parse(userinfo);
        // }

        return new Promise((resolve, reject) => {
            this.api("/admin/info", {}, (res) => {
                if (res.code == 10000) {
                    if(res.data.level_id<4){
                        Message.error('请先提升等级')
                        router.push('/service');
                    }
                    var host = window.location.host;
                    var id = host.split('.');
                    if(host.indexOf(':8082') == -1){
                        id = id[0];
                        id = id.replace('pad','');
                        if(id!=res.data.store_id){
                            Message.error('请重新登录');
                            this.api('/login/logout',{}, res => {
                                if(res.code == 10000){
                                    localStorage.removeItem('UserInfo');
                                    localStorage.removeItem('Router');
                                    Cookies.remove('ShopAdminToken', { path: '/' ,domain:'91jf.com'})
                                    router.push('/login');
                                }else{
                                    this.$message.error(res.msg);
                                }
                            });

                        }

                    }
                    localStorage.setItem("UserInfo",JSON.stringify(res.data));
                    resolve(res.data);
                }
            });
        });
    },
    routes() {
        // var res = localStorage.getItem("Router");

        // if(res != null){
        //     return JSON.parse(res);
        // }

        return new Promise((resolve, reject) => {
            this.api("/common/router", {}, (res) => {
                if (res.code == 10000) {
                    localStorage.setItem("Router",JSON.stringify(res.data));
                    resolve(res.data);
                }else if(res.code == 10036){
                    router.push('/login');
                }
            });
        });
    },
    getHost(){
        var host = window.location.host;
        var id = host.split('.');

        //测试用，全部正式上线后可以删除
        // if(host.indexOf(':8082') == -1){
        //     id = id[0];
        //     id = id.replace('pad','');
        //     host = 'http://' + id + '.91jf.com/newweb/index.php?tpl=shopadmin';
        // }else if(host.indexOf('43.143.71.86:8082')!=-1){
        //     host = 'http://test06.91jf.com:8080/91jf/newweb/index.php?tpl=shopadmin';
        // }else{
        //     host = 'http://nabin.91jf.com/newweb/index.php?tpl=shopadmin';
        // }

        
        return host;
    },
    inArray(search,array){
        for(var i in array){
            if(array[i]==search){
                return true;
            }
        }
        return false;
    },
    routerRequire(path) { //对路由的component解析
        return (resolve) => require([`@/views${path}`], resolve);
    },
    getTempSecret() {
        var _this = this;
        return new Promise((resolve, reject) => {
            const now = Math.floor(new Date().getTime() / 1000)
            const { expiredTime } = this
            if (expiredTime && now < expiredTime) {
                resolve()
            }else{
                let params = {};
                _this.api('/common/cos',params,function(res){
                    if(res.code == 10000){
                        let params = {
                            TmpSecretId: res.data.secret_id,
                            TmpSecretKey: res.data.secret_key,
                            SecurityToken: res.data.session_token,
                            ExpiredTime: res.data.expired_time,
                        }
                        _this.expiredTime = res.data.expired_time
                        _this.cos = new COS({
                            getAuthorization: (options, callback) => {
                                callback(params)
                            },
                        })
                        resolve()
                    }else{
                        reject(res.msg?res.msg:res)
                    }
                })
            }

        })
    },
    getImageUrl: async function(key) {
        await this.getTempSecret()
        return new Promise((resolve, reject) => {
            const { Bucket, Region } = this.options
            this.cos.getObjectUrl({ Bucket, Region, Key: key }, (err, data) => {
                if (err) {
                    reject()
                    return
                }

                resolve(data.Url.substring(0,data.Url.lastIndexOf('?')))
            })
        })
    },
    //上传图片到云存储
    cosUpload: async function(key,file, onProgress = () => {}) {
        //获取身份ID和秘钥
        await this.getTempSecret()
        //图片上传
        var _that = this;
        return new Promise((resolve, reject) => {
            _that.cos.putObject(
                {
                    Key: key, // 文件名
                    Body: file, //要上传的文件对象
                    onProgress, //进度条
                    ..._that.options,
                },
                (err, data) => {
                    if (data && data.statusCode === 200) {
                        //成功，获取图片路径
                        let imageUrl = '';
                        _that.getImageUrl(key).then(url => {
                            resolve(url.replace('91jf-10046268.cos.ap-shanghai.myqcloud.com','img3.91jf.com'))
                        })
                    } else {
                        Message.error('上传错误，请重试')
                        reject(err)
                    }
                }
            )
        })

    },
    getDay(day = 0) {
        var today = new Date();
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
        today.setTime(targetday_milliseconds); //注意，这行是关键代码
        var tYear = today.getFullYear();
        var tMonth = today.getMonth();
        var tDate = today.getDate();
        tMonth = doHandleMonth(tMonth + 1);
        tDate = doHandleMonth(tDate);
        return tYear + "-" + tMonth + "-" + tDate;
    },
    random(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charactersLength);
            result += characters.charAt(randomIndex);
        }

        return result;
    },
    filterNum(number){
        let nums = number
            .toString()
            .split('')
            .reverse()
        let res = []
        nums.forEach((num, index) => {
            res.push(num)
            if (index !== 0 && index !== nums.length - 1 && index % 3 === 2){
                res.push(',')
            }
        })
        return res.reverse().join('')
    },
    htmlAlert: function (str) {
        var s = "";
        if (str.length == 0) return "";
        s = str.replace(/&amp;/g, "&");
        s = s.replace(/&lt;/g, "<");
        s = s.replace(/&gt;/g, ">");
        s = s.replace(/&nbsp;/g, " ");
        s = s.replace(/&#39;/g, "\'");
        s = s.replace(/&quot;/g, "\"");
        s = s.replace(/\\/g, " ");
        s = s.replace(/<p>/g, " ");
        s = s.replace(/<\/p>/g, " ");
        return s;
    },
    htmlEncodeNbsp: function (str) {
        var s = "";
        if (!str) return "";
        s = str.replace(/&/g, "&amp;");
        s = s.replace(/</g, "&lt;");
        s = s.replace(/>/g, "&gt;");
        s = s.replace(/\s/g, " ");
        s = s.replace(/\'/g, "&#39;");
        s = s.replace(/\"/g, "&quot;");
        return s;
    },
    getIp(){
        axios.get('https://ip.91jf.com/vuegetip.php',{

        }).then(resp=>{
            var status = resp.status;
            var data = resp.data;

            if(status != 200){
                console.log('ip获取失败');
            }
            this.sourceip = data;
        }).catch(err=>{
            console.log(err);
        })
    },
    getRandomInt() {
        var min=1000000000;
        var max=9999999999;
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}